<template>
  <div class="page dashboard-page">
    <div v-if="roleKind === 'application'">
      <ApplicationHome />
    </div>
    <div v-else-if="roleKind === 'designer'">
      <DesignerHome />
    </div>
    <div v-else-if="roleKind === 'salesman'">
      <SalesmanHome />
    </div>
    <div v-else-if="roleKind === 'sales_director'">
      <SalesDirectorHome />
    </div>
    <div v-else-if="roleKind === 'merchandiser'">
      <MerchandiserHome />
    </div>
    <div v-else-if="roleKind === 'supplier_boss'">
      <SupplierBossHome />
    </div>
    <div v-else-if="roleKind === 'supplier'">
      <SupplierHome />
    </div>
    <div v-else-if="roleKind === 'cheif_pattern_making_officier'">
      <CheifPatternMakingOfficierHome />
    </div>
    <div v-else-if="roleKind === 'pattern_maker'">
      <PatternMakerHome />
    </div>
    <div v-else-if="roleKind === 'craftsman'">
      <CraftsmanHome />
    </div>
    <div v-else-if="roleKind === 'quality_inspector'">
      <QualityInspector />
    </div>
    <div v-else-if="roleKind === 'plate_reviewer'">
      <PlateReviewerHome />
    </div>
    <div v-else-if="roleKind === 'purchaser'">
      <PurchaserHome />
    </div>
    <div v-else>
      <NotAnyRoleHome />
    </div>
  </div>
</template>

<script>
  import { Vue, Component } from 'vue-property-decorator';
  import ApplicationHome from './application_home';
  import DesignerHome from './designer_home';
  import SalesmanHome from './salesman_home';
  import SalesDirectorHome from './sales_director_home';
  import MerchandiserHome from './merchandiser_home';
  import SupplierBossHome from './supplier_boss_home';
  import SupplierHome from './supplier_home';
  import CheifPatternMakingOfficierHome from './cheif_pattern_making_officier_home';
  import PatternMakerHome from './pattern_maker_home';
  import CraftsmanHome from './craftsman_home';
  import QualityInspector from './quality_inspector';
  import NotAnyRoleHome from './not_any_role_home';
  import PlateReviewerHome from './plate_reviewer_home';
  import PurchaserHome from './purchaser_home';
  import _ from 'lodash';

  @Component({
    components: {
      ApplicationHome,
      DesignerHome,
      SalesmanHome,
      SalesDirectorHome,
      MerchandiserHome,
      SupplierBossHome,
      SupplierHome,
      CheifPatternMakingOfficierHome,
      NotAnyRoleHome,
      PatternMakerHome,
      CraftsmanHome,
      QualityInspector,
      PlateReviewerHome,
      PurchaserHome
    }
  })
  export default class Home extends Vue {
    get roleKind() {
      return _.get(this.$root.user, 'current_role.role.kind');
    }
  }
</script>

<style lang="scss">
  .dashboard-page {
    margin-left: 20px;
    margin-right: 20px;

    .page-title {
      padding: 8px 20px;
      border-bottom: 1px solid $border-light;
      margin: 0;
      border-top-left-radius: 3px;
      border-top-right-radius: 3px;
      font-size: 14px;
      color: #fff;
      background: $primary;
    }

    .section {
      @include shadow;
      margin-top: 20px;
    }

    .content {
      background: #fff;
    }

    .wrapper {
      .card {
        .page-title {
          text-align: center;
          font-weight: bold;
        }

        .content {
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .item {
          flex: 1;
          height: 126px;
          margin: 0.5em 0;
          text-align: center;

          [class^="el-icon-"] {
            font-size: 30px;
            margin-top: 10px;
          }

          .name {
            margin-top: 15px;
            margin-bottom: 20px;
            font-size: 14px;
            color: #86888b;
          }

          .value {
            line-height: 78px;
            font-size: 24px;
          }
        }
      }
    }
  }
</style>
